import { useTranslation } from "react-i18next";
import Button from "../../components/buttons/button";
import { AiOutlinePlusCircle } from "react-icons/ai";
import { useState } from "react";
import Popup from "../../components/popups/popup";
import MessagePopup from "../../components/popups/messagePopup";
import Paginate from "../../components/pagination/paginate";
import SearchSelect from "../../components/select/searchSelect";
import { useOptions } from "../../components/hooks/useOptionsHook";
import { useNavigate } from "react-router-dom";
import StoreTable from "./storeTable";
import SearchStore from "./searchStore";
import DeleteProduct from "./deleteProduct";
import ProductDetails from "./productDetails";

const Store = () => {
  const { t } = useTranslation();
  const [openView, setOpenView] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const data = { last_page: 10 };
  const { paginationOptions } = useOptions();
  const navigate = useNavigate();
  return (
    <main>
      <div className="flex flex-wrap items-center justify-between md:flex-nowrap">
        <h1 className="mb-3 text-lg font-bold capitalize md:text-2xl text-primary">
          {t("storeManagement")}
        </h1>
        <Button
          onClick={() => navigate("/store/add")}
          className={"bg-primary text-black"}
          type={"button"}
        >
          <AiOutlinePlusCircle />
          {t("addNewProduct")}
        </Button>
      </div>
      <article className="mainLinear grid p-4 rounded-[20px] mt-8">
        <SearchStore t={t} />
        <StoreTable t={t} setOpenView={setOpenView} setOpenDelete={setOpenDelete} />
      </article>
      <div className="flex items-center gap-2">
        <Paginate data={data} />
        <div>
          <SearchSelect
            options={paginationOptions}
            onChange={(e) => {
              alert("now paginating " + e.value);
            }}
            name={"paginate"}
            placeholder={t("show 10")}
          />
        </div>
      </div>

      <Popup open={openView} setOpen={setOpenView} header={t("productDetails")}>
        <ProductDetails t={t} />
      </Popup>

      <MessagePopup open={openDelete} setOpen={setOpenDelete}>
        <DeleteProduct t={t} setOpen={setOpenDelete} />
      </MessagePopup>
    </main>
  );
};

export default Store;
